import { AtomicCall } from './types';
import { FieldSize } from 'shared/types/fieldSize';

export const MAX_FILE_DESCRIPTION_LENGTH = FieldSize.M;

export const atomicCall: AtomicCall = (
  config,
  actionName,
  params,
  fallback
) => {
  if (config.previewOnly) {
    return;
  }
  if (!config.atomicChanges) {
    return;
  }
  if (config.actions?.[actionName]) {
    //@ts-ignore TS does not understand that we checked if cnf.actions[actName] is defined
    config.actions[actionName](...params);
    return;
  }
  if (config.baseUrl) {
    fallback();
  }
  return;
};

export function areEqual(prevArray: any[], currArray: any[]): boolean {
  if (prevArray.length !== currArray.length) {
    return false;
  }

  return prevArray.every((prevFile) =>
    currArray.some((currFile) => {
      return currFile.localId === prevFile.localId;
    })
  );
}
